export default __webpack_public_path__ + "285213f.png";